/* eslint-disable max-classes-per-file */
/* eslint-disable import/prefer-default-export */

export class RequireApprovalFromUserError extends Error {}

export class RequestValidationFailedError extends Error {}
